import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  standalone: false,
    selector: "app-widget-loader",
    templateUrl: "./widget-loader.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./widget-loader.component.scss"],
})
export class WidgetLoaderComponent {
    constructor() {}
}
